import type {
	RankingInfo
} from "@tanstack/match-sorter-utils";
import type { FilterFn, SortingFn } from "@tanstack/react-table";

// sortingFns
import {
	compareItems,
	rankItem
} from "@tanstack/match-sorter-utils";
import { sortingFns } from "@tanstack/react-table";

declare module "@tanstack/react-table" {
	interface FilterFns {
		fuzzy?: FilterFn<unknown>;
		dateRange?: FilterFn<unknown>;
	}
	interface FilterMeta {
		itemRank: RankingInfo;
	}
}

export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
	const itemRank = rankItem(row.getValue(columnId), value);

	addMeta({
		itemRank
	});

	return itemRank.passed;
};

export const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
	let dir = 0;

	// Only sort by rank if the column has ranking information
	if (rowA.columnFiltersMeta[columnId]) {
		dir = compareItems(
			rowA.columnFiltersMeta[columnId]?.itemRank ?? 0,
			rowB.columnFiltersMeta[columnId]?.itemRank ?? 0
		);
	}
	// Provide an alphanumeric fallback for when the item ranks are equal
	return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

export const dateRangeFilter: FilterFn<any> = (row, columnId, value) => {
	const date = new Date(row.getValue(columnId));
	const [start, end] = value; // value => two date input values
	// If one filter defined and date is null filter it
	if ((start || end) && !date)
		return false;
	if (start && !end) {
		return date.getTime() >= start.getTime();
	}
	else if (!start && end) {
		return date.getTime() <= end.getTime();
	}
	else if (start && end) {
		return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
	}
	else {
		return true;
	}
};
